module.exports = __webpack_public_path__ + "media/images/front/products/extra/product_2-3c848db8eb512843ee0c9f7264d2c28a.jpg";